export abstract class NotificationItem {

  id: string;

  // sometimes it's better to let the application using the pds widget manage marking things read
  // a notification item with isMarkedReadOnClick false allows this to happen
  isMarkedReadOnClick = true;

  constructor(public type: string, public isSeen = false, public isRead = false, protected aggregationKey = '', public subtype?: string) {
  }

  getPostedAt(): Date | null {
    return null;
  }

  getColorClass(): string | null {
    return null;
  }

  getSource(): string | null {
    return null;
  }

  getTitle(): string {
    return this.type;
  }

  getSubtitle(): string | null {
    return null;
  }

  getUserType(): string | null {
    return null;
  }

  getTooltip(): string | null {
    return null;
  }

  getTooltipForSubtitle(): string | null {
    return null;
  }

  getSenderUid(): string | null {
    return null;
  }

  // This can be used for a notification that needs immediate attention. The notification must
  // implement support for this property directly, otherwise it has no effect. You might use this
  // to render notifications that need attention differenlty from the others to draw the user's
  // attention to them.
  getRequiresAction(): boolean {
    return false;
  }

  // the aggregation key is the value used by the notification indicator controller to determine which items should go
  // into a NotificationItemGroup. They are formed by taking the pieces of data that each object group is aggregated by
  // and putting them into an object which we then convert to a string. This serves a double use case of being able to
  // parse that key later and send it in events to uniquely identify which group was clicked.
  getAggregationKey(): string {
    if (this.aggregationKey != null && this.aggregationKey.length > 0) {
      let parsedKey = JSON.parse(this.aggregationKey);
      parsedKey.type = this.type;
      return JSON.stringify(parsedKey);
    }
    return JSON.stringify({
      type: this.type
    });
  }

  get lookUpKey(): string {
    return '';
  }
}
